module.exports = __webpack_public_path__ + "img/30.1f114fe1.jpg";